import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { getHolidayTypeLabel, HolidayTypeEnum } from "@altertec_gparn/lib";
import { Expose, Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";

export class CollectiveAgreementHolidayDto extends BaseEntityDto {
  @Expose()
  collectiveAgreementId: string;

  @Expose()
  @Transform(({ value }) => setTimeToMidday(toLocaleTimezone(parseApiDate(value))))
  date: Date;

  @Expose()
  name?: string;

  @Expose()
  type: HolidayTypeEnum;

  @Expose()
  year: number;

  @Expose()
  description?: string;

  toString(): string {
    const trimmedName = this.name?.trim();
    if (trimmedName) return trimmedName;
    return getHolidayTypeLabel(this.type);
  }
}
